export default [
  {
    path: '/admin',
    name: 'admin',
    component: () => import('@/layouts/main/Admin.vue'),
    redirect: { name: 'admin.announcements' }, // TODO: Redirect to dashboard when available.
    children: [
      {
        path: 'dashboard',
        name: 'admin.dashboard',
        component: () => import('@/views/Admin/Dashboard.vue'),
        redirect: { name: 'admin.announcements' } // TODO: Remove this when admin dashboard is fixed.
      },
      {
        path: 'announcements',
        name: 'admin.announcements',
        component: () => import('@/views/Admin/Announcements.vue')
      },
      {
        path: 'management',
        name: 'management',
        component: () => import('@/views/Admin/Management.vue'),
        redirect: { name: 'admin.management.company' },
        children: [
          {
            path: 'company',
            name: 'admin.management.company',
            component: () => import('@/views/Admin/Management/Company.vue')
          },
          {
            path: 'api-key',
            name: 'admin.management.apiKey',
            component: () => import('@/views/Admin/Management/ApiKey.vue')
          },
          {
            path: 'manager',
            name: 'admin.management.manager',
            component: () => import('@/views/Admin/Management/Manager.vue')
          }
        ]
      },
      {
        path: 'ring-group',
        name: 'admin.ringGroup',
        component: () => import('@/views/Admin/RingGroup.vue')
      },
      {
        path: 'messages',
        name: 'admin.messages',
        component: () => import('@/views/Admin/Messages.vue'),
        redirect: { name: 'admin.messages.load' },
        children: [
          {
            path: 'load',
            name: 'admin.messages.load',
            component: () => import('@/views/Admin/Messages/Load.vue')
          }
        ]
      },
      {
        path: 'my-account',
        name: 'admin.my-account',
        component: () => import('@/views/Admin/MyAccount.vue'),
        redirect: { name: 'admin.my-account.personal-information' },
        children: [
          {
            path: 'personal-information',
            name: 'admin.my-account.personal-information',
            component: () => import('@/views/Admin/MyAccount/PersonalInformation.vue')
          },
          {
            path: 'change-password',
            name: 'admin.my-account.change-password',
            component: () => import('@/views/Admin/MyAccount/ChangePassword.vue')
          }
        ]
      },

      {
        path: 'tasks',
        name: 'admin.tasks',
        component: () => import('@/views/Admin/Tasks.vue')
      },
      {
        path: 'servers',
        name: 'admin.servers',
        component: () => import('@/views/Admin/Servers.vue'),
        redirect: { name: 'admin.servers.server' },
        children: [
          {
            path: 'servers',
            name: 'admin.servers.servers',
            component: () => import('@/views/Admin/Servers/Servers.vue')
          },
          {
            path: 'databases',
            name: 'admin.servers.databases',
            component: () => import('@/views/Admin/Servers/Databases.vue')
          },
          {
            path: 'nodes',
            name: 'admin.servers.nodes',
            component: () => import('@/views/Admin/Servers/Nodes.vue')
          }
        ]
      }
    ]
  }
]
